/**
 * Sequences — Zahlenfolgen-Rätsel.
 * Basiert auf universellen mathematischen Konzepten
 * (arithmetische Folgen, Quadrate, Fibonacci, Primzahlen, Potenzen).
 */
export const SEQUENCES = [
  { id: 'seq01', cat: 'sequences', diff: 1,
    q: 'Welche Zahl folgt? 2, 4, 6, 8, ?', a: '10',
    hint: 'Schrittweite konstant', exp: '+2 pro Schritt' },

  { id: 'seq02', cat: 'sequences', diff: 1,
    q: 'Welche Zahl folgt? 10, 20, 30, 40, ?', a: '50',
    hint: 'Zehnerschritte', exp: '+10 pro Schritt' },

  { id: 'seq03', cat: 'sequences', diff: 1,
    q: 'Welche Zahl folgt? 3, 6, 9, 12, ?', a: '15',
    hint: 'Vielfache von 3', exp: '+3 pro Schritt' },

  { id: 'seq04', cat: 'sequences', diff: 2,
    q: 'Welche Zahl folgt? 1, 4, 9, 16, ?', a: '25',
    hint: 'Quadratzahlen', exp: '1², 2², 3², 4², 5² = 25' },

  { id: 'seq05', cat: 'sequences', diff: 2,
    q: 'Welche Zahl folgt? 1, 1, 2, 3, 5, 8, ?', a: '13',
    hint: 'Vorgänger addieren', exp: 'Fibonacci: 5 + 8 = 13' },

  { id: 'seq06', cat: 'sequences', diff: 2,
    q: 'Welche Zahl folgt? 2, 5, 10, 17, ?', a: '26',
    hint: 'Differenzen: +3, +5, +7, ...', exp: 'Differenzen wachsen um 2: +9 → 26' },

  { id: 'seq07', cat: 'sequences', diff: 2,
    q: 'Welche Zahl folgt? 3, 6, 12, 24, ?', a: '48',
    hint: 'Verdoppeln', exp: '× 2 pro Schritt' },

  { id: 'seq08', cat: 'sequences', diff: 3,
    q: 'Welche Zahl folgt? 1, 8, 27, 64, ?', a: '125',
    hint: 'Hoch 3', exp: 'Kubikzahlen: 5³ = 125' },

  { id: 'seq09', cat: 'sequences', diff: 3,
    q: 'Welche Zahl folgt? 2, 3, 5, 7, 11, ?', a: '13',
    hint: 'Spezielle Zahlen', exp: 'Primzahlen: nach 11 kommt 13' },

  { id: 'seq10', cat: 'sequences', diff: 3,
    q: 'Welche Zahl folgt? 1, 3, 7, 15, 31, ?', a: '63',
    hint: 'Verdoppeln und addieren', exp: '× 2 + 1 → 31·2+1 = 63' },

  { id: 'seq11', cat: 'sequences', diff: 3,
    q: 'Welche Zahl folgt? 100, 90, 81, 73, ?', a: '66',
    hint: 'Differenz wächst absteigend', exp: 'Differenzen: -10,-9,-8,-7 → 66' },

  { id: 'seq12', cat: 'sequences', diff: 3,
    q: 'Welche Zahl folgt? 4, 9, 16, 25, ?', a: '36',
    hint: 'Quadrate ab 2', exp: '2², 3², 4², 5², 6² = 36' },

  { id: 'seq13', cat: 'sequences', diff: 4,
    q: 'Welche Zahl folgt? 1, 2, 6, 24, 120, ?', a: '720',
    hint: 'Fakultäten', exp: '6! = 720' },

  { id: 'seq14', cat: 'sequences', diff: 4,
    q: 'Welche Zahl folgt? 1, 2, 4, 7, 11, 16, ?', a: '22',
    hint: 'Differenzen +1 jeweils', exp: '+1, +2, +3, +4, +5, +6 → 22' },

  { id: 'seq15', cat: 'sequences', diff: 4,
    q: 'Welche Zahl folgt? 2, 6, 12, 20, 30, ?', a: '42',
    hint: 'n·(n+1)', exp: '1·2, 2·3, 3·4, 4·5, 5·6, 6·7 = 42' },

  { id: 'seq16', cat: 'sequences', diff: 2,
    q: 'Welche Zahl folgt? 64, 32, 16, 8, ?', a: '4',
    hint: 'Halbieren', exp: '÷ 2 pro Schritt' },

  { id: 'seq17', cat: 'sequences', diff: 2,
    q: 'Welche Zahl folgt? 5, 11, 17, 23, ?', a: '29',
    hint: '+6 pro Schritt', exp: 'Arithmetische Folge mit Schritt 6' },

  { id: 'seq18', cat: 'sequences', diff: 4,
    q: 'Welche Zahl folgt? 1, 11, 21, 1211, 111221, ?', a: '312211',
    hint: 'Beschreibe die vorherige Zahl', exp: '"drei 1, zwei 2, ein 1" = 312211 (Look-and-Say)' },

  { id: 'seq19', cat: 'sequences', diff: 3,
    q: 'Welche Zahl fehlt? 7, 14, 28, ?, 112', a: '56',
    hint: 'Verdoppeln', exp: '× 2 pro Schritt: 28·2 = 56' },

  { id: 'seq20', cat: 'sequences', diff: 1,
    q: 'Welche Zahl folgt? 0, 5, 10, 15, ?', a: '20',
    hint: 'Vielfache von 5', exp: '+5 pro Schritt' },
];
